<template>
  <tg-layout :headerHeight="headerHeight">
    <template slot="header">
      <tg-search-tool
        @on-submit="handleSearch"
        :disabled="!searchData.bet_id && !searchData.targetName"
      >
        <tg-dropdown
          :items="dropdown"
          @on-change="handleChange"
          trigger="click"
          :value="1"
        >
        </tg-dropdown>
        <tg-date-search
          ref="dateSearch"
          size="small"
          v-model="dateRange"
          showDateRangePicker
          showTomorrow
          twoMonthLimit
        ></tg-date-search>
        <el-input
          :placeholder="$t('component.form.input.placeholder.bet_id')"
          v-model="searchData.bet_id"
          class="tg-input"
          size="small"
          style="width: 120px"
          clearable
        ></el-input>

        <template>
          <div class="tg-btn--radio" >
            <tg-dropdown
              :items="dropdownGroup"
              @on-change="handleChangeGroup"
              trigger="click"
              :value="defaultGroup"
              :styleObject="{border:0}"
            >
            </tg-dropdown>
            <el-divider direction="vertical"></el-divider>
            <el-input
              :placeholder="$t('component.form.input.placeholder.username')"
              v-model="searchData.targetName"
              class="tg-input border-none input-search-username"
              size="small"
              clearable
            ></el-input>
          </div>
        </template>


        <!-- <template>
          <div class="tg-btn--radio"  style="margin-left:5px;">
            <tg-dropdown
              :items="dropdownOption"
              @on-change="handleChangeOption"
              trigger="click"
              :styleObject="{border:0}"
            >
            </tg-dropdown>
            <el-divider direction="vertical"></el-divider>
            <tg-dropdown
              :items="dropdownValidStatus"
              @on-change="handleChangeValidStatus"
              trigger="click"
              :styleObject="{border:0}"
            >
            </tg-dropdown> 
          </div>
        </template>-->
      </tg-search-tool>
      <el-row style="padding:5px;">
        <!-- 平台選擇按鈕 -->
        <third-party-search-btn
          :style="{'display': !showThirdParty ? 'none': 'initial'}"
          @click.native="showThirdPartyCheckBoxDialog"
        ></third-party-search-btn>
        <third-party-platform
          :style="{'display': !showThirdParty ? 'none': 'initial'}"
          v-model="third_party"
          @on-change="handleSearchThirdParty"
        ></third-party-platform>
      </el-row>
    </template>
    <tg-table
      v-if="!showNodata"
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      showPagination
      @on-loaded="handleLoaded"
    >
      <template slot="userfullname" slot-scope="scope">
        <tg-user-full-name
          :row="scope.row"
          :column="scope.column"
        ></tg-user-full-name>
      </template>

      <!-- 單號 -->
      <template slot="betId" slot-scope="scope">
        <tg-bet-id :row="scope.row"></tg-bet-id>
      </template>

      <template slot="deviceInfo" slot-scope="scope">
        <span v-if="scope.row.ip">{{ scope.row.ip }}</span>
      </template>
      
      <!-- 平台 -->
      <template slot="source_type" slot-scope="scope">
        <span :class="['text-' +  scope.row.source_type]">
          {{ $t("component.label.source_type." + scope.row.source_type) }}
        </span>
      </template>

      <!-- 賽事內容 -->
      <template slot="betContent" slot-scope="scope">
        <tg-bet-content v-if="scope.row.source_type == 'tg'" :row="scope.row"></tg-bet-content>
        <third-party-saba-bet-content
          v-else-if="
            ((scope.row.source_type == 'saba' || scope.row.source_type == 'sabawhite_sport') &&
            (scope.row.content_type == 2 || scope.row.content_type == 5))
            || (scope.row.source_type.includes('sport') && scope.row.serial_type == 1) //serial_type == 1 非串關
          "
          :row="scope.row"
        ></third-party-saba-bet-content>
        <third-party-saba-parlay-bet-content
          v-else-if="
            (scope.row.source_type == 'saba' || scope.row.source_type == 'sabawhite_sport') &&
            (scope.row.content_type == 3 || scope.row.content_type == 4)
          "
          :row="scope.row"
          @on-click="handlePublicParlayDialog(scope.row)"
        ></third-party-saba-parlay-bet-content>
        <third-party-saba-parlay-bet-content
          v-else-if="
            (scope.row.source_type != 'saba' && scope.row.source_type.includes('sport')) 
          "
          :row="scope.row"
          @on-click="handlePublicParlayDialog(scope.row)"
        ></third-party-saba-parlay-bet-content>
        <third-party-public-bet-content
          v-else
          :row="scope.row"
        ></third-party-public-bet-content>
      </template>

      <template slot="isAccounted" slot-scope="scope">
          <!-- 已過帳 -->
          <span v-if="scope.value == 1 || scope.value == true"
            >{{ $t("enum.isAccounted[1]") }}<br
          /></span>
          <!-- 未過帳 -->
          <span v-else>{{ $t("enum.isAccounted[0]") }}</span>
      </template>

      <!-- 注單結果 -->
      <span
        slot="after"
        slot-scope="props"
        :class="{
          'text-red': props.value < 0,
          'text-green': props.value > 0,
        }"
        v-if="props.row.isAccounted == 1"
        >{{ props.formated }}
      </span>

      <template slot="note" slot-scope="scope">
        <!-- 保本 -->
        <span v-if="scope.row.status_id == 1"
          >{{ $t("enum.status_id[1]") }}<br
        /></span>
        <!-- VIP保本 -->
        <span v-if="scope.row.status_id == 2"
          >{{ $t("enum.status_id[2]") }}<br
        /></span>
        <!-- 體驗金注單 -->
        <span v-if="scope.row.errorCode == 1"
          >{{ $t("enum.historyErrorCode[" + scope.row.errorCode + "]") }}<br
        /></span>
        <!-- 智能下單設置編號 -->
        <span v-if="scope.row.smart_no != null">
          {{ $t("component.label.smart_no") + "-" + scope.row.smart_no }}<br />
        </span>
        <!-- 同秒同注單 -->
        <span
          v-if="scope.row.same_type != null && scope.row.same_type < 99"
          :class="{ 'text-red': true }"
        >
          {{ $t("component.label.same_type[" + scope.row.same_type + "]") }}
        </span>
        <!-- 重新结算 (當該注單重新結算時顯示) -->
        <span
          v-if="scope.row.isReCount == 1"
          :class="{ 'text-red': true }"
        >
          {{ $t("component.label.recount") }}
        </span>

        <!-- WM真人 住單【有重對】時顯示【重新結算】 -->
        <span
          v-if="scope.row.content_type == 6 && scope.row.wm_reset == 1"
          :class="{ 'text-red': true }"
        >
          {{ $t("component.label.recount") }}
        </span>

        <!-- 各平台備註 -->
        <span
          v-if="scope.row.note "
          :class="{ 'text-red': true }"
        >
          {{ scope.row.note }}
        </span>

        <template v-if="scope.row.source_type == 'cq9_gaming'">
          <template v-if="scope.row.detail_free_game > 0 && scope.row.single_row_bet > 0">
            <!-- 付費再旋轉/免費遊戲 -->
            <span>
              {{ $t("component.label.respin_game") }}/{{ $t("component.label.free_game") }}
            </span>
          </template>
          <template v-else-if="scope.row.detail_free_game > 0">
            <!-- 免費遊戲 -->
            <span>
              {{ $t("component.label.free_game") }}
            </span>
          </template>
          <template v-else-if="scope.row.detail_bonus > 0">
            <!-- 翻倍遊戲 -->
            <span>
              {{ $t("component.label.gamble_game") }}
            </span>
          </template>
          <template v-else-if="scope.row.single_row_bet > 0">
            <!-- 付費再旋轉 -->
            <span>
              {{ $t("component.label.respin_game") }}
            </span>
          </template>
          <template v-else-if="scope.row.jackpot > 0">
            <!-- 累積彩金 -->
            <span>
              {{ $t("component.label.stack_up_bonus") }}
            </span>
          </template>
        </template>

        <template v-if="scope.row.source_type == 'bbin_casino'">
          <template v-if="scope.row.bet_status == 1">
            <!-- 已取消 -->
            <span>
              {{ $t("enum.bet_status[0]") }}
            </span>
          </template>
        </template>

        <template v-if="scope.row.source_type == 'ob_sport'">
          <template v-if="scope.row.bet_status == 2">
            <!-- 已取消 -->
            <span>
              {{ $t("enum.bet_status[0]") }}
            </span>
          </template>
          <template v-else-if="scope.row.bet_status == 4">
            <!-- 風控拒單 -->
            <span>
              {{ $t("component.label.risk_control_rejection") }}
            </span>
          </template>
          <template v-else-if="scope.row.bet_status == 5">
            <!-- 撤單 -->
            <span>
              {{ $t("component.label.cancel") }}
            </span>
          </template>
        </template>

        <template v-if="scope.row.source_type == 'im_sport'">
          <template v-if="scope.row.isResettled == 1">
            <!-- 重新結算 -->
            <span
              v-if="scope.row.isResettled == 1"
              :class="{ 'text-red': true }"
            >
              {{ $t("component.label.recount") }}
            </span>
          </template>
        </template>
        
      </template>
    </tg-table>
    <template v-if="showNodata">
      <div class="tg-bg-white">
        <tg-nodata :isNeedSearchWithBetId="!isSearch"></tg-nodata>
      </div>
    </template>

    <!-- 沙巴串關詳情 -->
    <third-party-saba-detail-dialog
      ref="sabaParlayMatchs"
    ></third-party-saba-detail-dialog>
    <!-- 沙巴串關結果 -->
    <third-party-saba-result-dialog
      ref="sabaParlayResult"
    ></third-party-saba-result-dialog>

    <!-- 平台篩選彈窗 -->
    <third-party-check-box-dialog
      ref="thirdPartyCheckBoxDialog"
      :third_party="third_party"
      @on-click="handleSearchThirdParty"
    ></third-party-check-box-dialog>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgBetId from "@/components/slot/TgBetId";
import TgBetContent from "@/components/slot/TgBetContent";
import TgUserFullName from "@/components/slot/TgUserFullName";
import TgTable from "@/components/table/TgTable";
import TgNodata from "@/components/TgNodata";
import ThirdPartySabaBetContent from "@/components/slot/ThirdPartySabaBetContent";
import ThirdPartySabaParlayBetContent from "@/components/slot/ThirdPartySabaParlayBetContent";
import ThirdPartySabaDetailDialog from "@/components/dialog/ThirdPartySabaDetailDialog";
import ThirdPartySabaResultDialog from "@/components/dialog/ThirdPartySabaResultDialog";
import ThirdPartyPublicBetContent from "@/components/slot/ThirdPartyPublicBetContent";
import ThirdPartyCheckBoxDialog from "@/components/dialog/ThirdPartyCheckBoxDialog";
import ThirdPartySearchBtn from "@/components/button/ThirdPartySearchBtn";
import ThirdPartyPlatform from '@/components/tool/ThirdPartyPlatform';

import apis from "@/apis";
import {sabaParlayHandler} from "@/mixins/betContent";
import {thirdPartyCheckBoxDialogHandler} from "@/mixins/third_party/dialog";

const api = apis.accounts.bet;

const defaultBetOptions = apis.accounts.public.getBetDefaultOptions();

export default {
  components: {
    TgLayout,
    TgSearchTool,
    TgDropdown,
    TgDateSearch,
    TgBetId,
    TgBetContent,
    TgUserFullName,
    TgTable,
    TgNodata,
    ThirdPartySabaBetContent,
    ThirdPartySabaParlayBetContent,
    ThirdPartySabaDetailDialog,
    ThirdPartySabaResultDialog,
    ThirdPartyPublicBetContent,
    ThirdPartyCheckBoxDialog,
    ThirdPartySearchBtn,
    ThirdPartyPlatform
  },
  mixins: [sabaParlayHandler,thirdPartyCheckBoxDialogHandler],
  data() {
    return {
      columns: [],
      proxy: api.getData,
      dateRange: {},
      searchData: {
        targetName: "",
        time_type: 1,
        bet_id: null,
        third_party: [],
        userType:10,
        betOption:0,
        flowStatus:0
      },
      third_party:[],
      dropdown: [], // 交易時間、開賽時間,
      dropdownGroup:[],//通路層級
      dropdownOption:[],//注單類型:全部(預設)、保本、保險、智能下單
      dropdownValidStatus:[],//全部、有效注單(預設)、無效注單
      defaultGroup:{},
      showNodata: true,
      isSearch: false,
    };
  },
  computed: {
    headerHeight() {
      return !this.showAmount ? 120 : 160;
    },
    request() {
      return { ...this.searchData, ...this.dateRange };
    },
  },
  created() {
    defaultBetOptions.then((result) => {
      this.dropdownOption = JSON.parse(result.data);
    });
    
    api.getColumns().then((response) => {
      this.columns = response.data.columns;
      this.dropdown = this.parseDropdown(response.data.dropdown);
      this.dropdownGroup = this.parseDropdownGroup(this.groupMap(this.$store.state.app.user.group));
      // 預設會員
      this.searchData.userType = 10;
      this.defaultGroup = this.dropdownGroup.filter((x) => x.value == 10)[0];
      response.data.dropdownOption.forEach(item => {
        this.dropdownOption.push(item);
      });

      this.dropdownOption.forEach(item => {
        item.label = this.$t(item.langKey);
      });
      // this.dropdownOption = this.parseDropdownOption(response.data.dropdownOption);
      this.dropdownValidStatus = this.parseDropdownValidStatus(response.data.dropdownValidStatus);
    });
  },
  methods: {
    handleSearch() {
      this.showNodata = false;
      this.isSearch = true;

      this.$nextTick(() => {
        this.$refs.table.search(this.request);
      });
    },
    handleChange(item) {
      this.searchData.time_type = item.value;
    },
    handleChangeGroup(item) {
      this.searchData.userType = item.value;
    },
    handleChangeOption(item) {
      this.searchData.betOption = item.value;
    },
    handleChangeValidStatus(item) {
      this.searchData.flowStatus = item.value;
    },
    handleLoaded(response) {
      if (response.retcode == 0) {
        let columns = JSON.parse(JSON.stringify(this.columns));
        this.columns = columns;
      }
    },
    parseDropdown(dropdown) {
      return dropdown.map((item) => {
        return {
          label: this.$t("component.dropdown.search_bet[" + item + "]"),
          value: item,
        };
      });
    },
    parseDropdownGroup(dropdown) {
      return dropdown.map((item) => {
        return {
          label: this.$t("column.l" + item ),
          value: item,
        };
      });
    },
    // parseDropdownOption(dropdown) {
    //   return dropdown.map((item) => {
    //     return {
    //       label: this.$t("enum.betDropDownOptions[" + item + "]"),
    //       value: item,
    //     };
    //   });
    // },
    parseDropdownValidStatus(dropdown) {
      return dropdown.map((item) => {
        return {
          label: this.$t("enum.betDropDownValidStatus[" + item + "]"),
          value: item,
          active:  item == 1
        };
      });
    },
    handleSearchThirdParty(value) {
      this.third_party = value;
      this.searchData.third_party = this.third_party.map(r => {
        return r.platform;
      });

      if(this.searchData.bet_id || this.searchData.targetName){
        this.$nextTick(() => {
          this.handleSearch();
        });
      }
    },
    groupMap(group) {
      return [70, 60, 40, 20, 10].filter((x) => x < group);
    },
  }
};
</script>